<template>
    <div>
        <div class="Coupon_view" v-for="(item,index) in couponList" :key="index" @click="Coupon(item,index)" >
            <div v-if="item.useStatus===0">
                <div class="Coupon_div">
                    <div class="Con_ishs">
                        <span class="on_d">{{item.coupon[0].amount}}</span>
                        <span class="On_Done">元</span>
                    </div>
                    <div class="Conuos_sjq">
                        <span>{{item.coupon[0].name}}</span><br>
                        <span>{{item.coupon[0].startTime}}-{{item.coupon[0].endTime}}</span>
                    </div>
                </div>
                <div class="Coupon_Mvvm">
                    {{item.coupon[0].note}}
                </div>
            </div>
        </div>
        <div class="absolute" @click="goReturn">不使用优惠券</div>
    </div>
</template>
<script>
// import { coupon } from '@/request/api'
import { Toast } from 'vant'
// import bus from '@/utils/bus'
export default {
  components: {
    [Toast.name]: Toast
  },
  data() {
    return {
      couponList: []
    }
  },
  methods: {
    goReturn() {
      sessionStorage.setItem('couponId', '')
      sessionStorage.setItem('amount', '')
      sessionStorage.setItem('amountIndex', '')
      this.$router.go(-1)
    },
    Coupon(e, i) {
      console.log(e, i)
      //   bus.$emit('couponId', e.id)
      //   bus.$emit('amount', e.coupon[0].amount)
      //   bus.$on('couponId', (e) => {
      //   this.couponId = e
      // })
      // bus.$on('amount', (e) => {
      //   this.couponAmount = e
      // })
      this.$set(e, 'trueone', 1)
      sessionStorage.setItem('couponId', e.id)
      sessionStorage.setItem('amount', e.coupon[0].amount)
      sessionStorage.setItem('amountIndex', i)
      this.$router.go(-1)
    }
  },
  mounted() {
  },
  created() {
    console.log(JSON.parse(this.$route.query.couponList))
    this.couponList = JSON.parse(this.$route.query.couponList)
  }
}
</script>
<style lang="less" scoped>
    .Coupon_view{
        width: 100%;
        height: 242px;
        background: url('../../assets/Coupon.png') no-repeat;
        background-size: 100% 100%;
        margin-bottom: 25px;
        .Coupon_div{
            height: 172px;
            margin-left: 32px;
            color:rgba(255,255,255,1);
            display: flex;
            justify-content: space-between;
            .Con_ishs{
                margin-top: 10px;
            }
            .on_d{
                font-size:100px;
                font-weight:bold;
                color:rgba(255,255,255,1);
            }
            .On_Done{
                font-size: 32px;
            }
            .Conuos_sjq{
                margin-right: 20px;
                margin-top: 50px;
                span:nth-child(1){
                    font-size: 32px;
                }
                span:nth-child(3){
                    padding-top: 15px;
                    font-size: 25px;
                }
            }
        }
        .Coupon_Mvvm{
            height: 70px;
            display: inline-flex;
            align-items: center;
            margin-left: 32px;
            font-size: 24px;
            color:rgba(255,255,255,1);
        }
    }
    .absolute {
      width: 100%;
      position: fixed;
      bottom: 0;
      height:58px;
      font-size: 26px;
      display: flex;
      justify-content: center;
      align-items: center ;
    }
</style>
